import Comment from './Comment';
import DiagnosticColor from '@/models/DiagnosticColor';

export default class InterpretedWellDiagnostic {
  constructor(id, stateDiagnostic, comment, diagnosticColor, diagnosticLabel) {
    this.id = id;
    this.stateDiagnostic = stateDiagnostic;
    this.diagnosticColor = diagnosticColor;
    this.diagnosticLabel = diagnosticLabel;
    this.comment = comment;
  }

  static build({ id, stateDiagnostic, comment, diagnosticColor, diagnosticLabel }) {
    return new InterpretedWellDiagnostic(id, stateDiagnostic, comment, diagnosticColor, diagnosticLabel);
  }

  static parse(value) {
    return value ? InterpretedWellDiagnostic.build({
      id: value.id,
      stateDiagnostic: value.stateDiagnostic,
      diagnosticColor: DiagnosticColor.parse(value.diagnosticColor),
      diagnosticLabel: value.diagnosticLabel,
      comment: Comment.parse(value.comment)
    }) : null;
  }
}
